import React, { useState, useMemo } from 'react';
import {
  Drawer,
  Box,
  Typography,
  TextField,
  Divider,
  Stack,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { HELP_TEXTS } from '../constants';
import { setHelpDrawerOpen } from '../../../../redux/d2cAllocationSlice';

export default function HelpDrawer() {
  const dispatch = useDispatch();
  const open = useSelector((s) => s.d2cAllocation.helpDrawerOpen);
  const [query, setQuery] = useState('');

  const entries = useMemo(() => {
    const all = Object.entries(HELP_TEXTS);
    if (!query.trim()) return all;
    const q = query.toLowerCase();
    return all.filter(
      ([key, val]) =>
        key.toLowerCase().includes(q) ||
        val.title.toLowerCase().includes(q) ||
        val.body.toLowerCase().includes(q),
    );
  }, [query]);

  return (
    <Drawer anchor="right" open={open} onClose={() => dispatch(setHelpDrawerOpen(false))}>
      <Box sx={{ width: 420, p: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            📘 Help &amp; definitions
          </Typography>
          <IconButton onClick={() => dispatch(setHelpDrawerOpen(false))}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <TextField
          fullWidth
          size="small"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search help topics…"
          sx={{ mb: 2 }}
        />
        <Stack spacing={2} divider={<Divider flexItem />}>
          {entries.map(([key, val]) => (
            <Box key={key}>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
                {val.title}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary', mb: 0.5 }}>
                {val.body}
              </Typography>
              {val.example ? (
                <Typography variant="caption" sx={{ fontStyle: 'italic', color: 'text.disabled' }}>
                  Example — {val.example}
                </Typography>
              ) : null}
            </Box>
          ))}
          {entries.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              No topics match your search.
            </Typography>
          ) : null}
        </Stack>
      </Box>
    </Drawer>
  );
}
